import AcceptRejectLessonRemovedManager from './container';

export default AcceptRejectLessonRemovedManager;
